import { ApolloError } from '@apollo/client';
export const getErrors = (err) => {
    let graphqlErrors = [];
    const networkError = err.networkError;
    if (err.graphQLErrors && err.graphQLErrors.length > 0) {
        graphqlErrors = err.graphQLErrors;
    }
    else if (networkError && networkError.data && networkError.data.errors) {
        graphqlErrors = networkError.data.errors;
    }
    const errors = [];
    graphqlErrors.forEach(({ message, extensions }) => {
        if (!extensions) {
            return;
        }
        errors.push({
            code: extensions.code,
            status: extensions.status,
            message,
            metadata: extensions.metadata,
        });
    });
    return errors;
};
export const queryCustomError = (errors, query) => errors.find((x) => (typeof query.status !== 'undefined' ? x.status === query.status : true) &&
    (query.code ? x.code === query.code : true));
export const queryApolloError = (err, query) => queryCustomError(getErrors(err), query);
export const hasCustomError = (errors, status, code) => errors.find((x) => x.status === status && (code ? x.code === code : true));
export const hasApolloError = (err, status, code) => hasCustomError(getErrors(err), status, code);
export const getErrorByCode = (err, code) => getErrors(err).find((e) => e.code === code);
export const makeGraphQLError = (status, code, message, metadata) => {
    return new ApolloError({
        graphQLErrors: [
            {
                message,
                extensions: {
                    code,
                    status,
                    metadata,
                },
                locations: [],
                source: undefined,
                path: [],
                positions: [],
                originalError: new Error(message),
                nodes: [],
                name: code,
            },
        ],
    });
};
//# sourceMappingURL=errors.js.map